import { render } from "./Experts-vue.vue?vue&type=template&id=2674f74a&scoped=true"
import script from "./Experts-vue.vue?vue&type=script&lang=js"
export * from "./Experts-vue.vue?vue&type=script&lang=js"

import "./Experts-vue.vue?vue&type=style&index=0&id=2674f74a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2674f74a"]])

export default __exports__